import styled from "styled-components";
import { RowBase } from "./TableComponents";
import RowMenu from "./RowMenu";
import { getTheme } from "Theme";

const theme = getTheme();

const DoubleRow = styled(RowBase)`
  display: flex;
  background-color: ${(props) =>
    props.highlight
      ? props.highlight
      : !!props.unread
        ? theme.SECONDARY_COLOR
        : theme.TABLE_ROW_ALT};
`;

const DoubleRowColumn = styled.td`
  width: ${(props) => props.width};
  display: flex;
  flex-direction: column;
`;

const NotificationSubject = styled.div`
  font-weight: bold;
`;

const NotificationMessage = styled.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
`;

export const Data = styled.div`
  font-weight: bold;
  width: ${(props) => props.width || "100%"};
  overflow-wrap: anywhere;
  margin: 0px 4px;
  text-align: ${(props) => (props.centered ? "center" : "left")};
`;

const getPrettyDate = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const dateString = date.toLocaleDateString();
  const timeString = date
    .toLocaleTimeString([], { hour: "numeric", minute: "numeric" })
    .toLowerCase();
  return `${dateString}-${timeString}`;
};
/**
 * Table row element used for notifications. It is aware of the data, but the table it is in is not.
 *
 * @param {*} data - The complete dataset being used, provided for simplicity.
 * @param {*} index - The index of the specific data used to populate this row.
 * @param {*} headers - The headers used for populating the row columns. Not used for the Notification Row.
 * @param {*} onClick - Callback used to respond to user clicks.
 * @param {*} onLimit
 * @param {*} menu
 * @param {*} rowHighlight
 * @param {*} quickMenuOpen
 * @param {*} onQuickMenuClick
 * @param {*} menuOpen
 * @param {*} onMouseEnterRow
 * @param {*} onMouseLeaveRow
 * @param {*} quickMenuOption
 * @returns
 */
export const NotificationRow = ({
  data,
  index,
  headers,
  onClick,
  onLimit,
  menu,
  rowHighlight,
  quickMenuOpen,
  onQuickMenuClick,
  menuOpen,
  onMouseEnterRow,
  onMouseLeaveRow,
  quickMenuOption,
}) => {
  const rowContents = headers.map((header, index) => {
    switch (index) {
      case 0: {
        // Notification column
        return (
          <DoubleRowColumn key={index} width={header.width}>
            <NotificationSubject>{data.subject}</NotificationSubject>
            <NotificationMessage>{data.message}</NotificationMessage>
          </DoubleRowColumn>
        );
      }
      case 1: {
        // From column
        return (
          <DoubleRowColumn
            key={index}
            width={header.width}
            centered={header.centered}
          >
            <Data centered={header.centered}>{data.sentByName}</Data>
          </DoubleRowColumn>
        );
      }
      case 2: {
        // Created At column
        return (
          <DoubleRowColumn
            key={index}
            width={header.width}
            centered={header.centered}
          >
            <Data centered={header.centered}>
              {getPrettyDate(data.createdAt)}
            </Data>
          </DoubleRowColumn>
        );
      }
      default:
        return <td></td>;
    }
  });

  return (
    <DoubleRow
      odd={index % 2}
      highlight={rowHighlight && rowHighlight(data)}
      clickable={!!onClick}
      onMouseEnter={() => onMouseEnterRow(index)}
      onMouseLeave={() => onMouseLeaveRow(null)}
      key={index}
      onClick={() => onClick && onClick(data, index)}
      unread={data.readAt ? undefined : true}
    >
      {rowContents}
      {menu && (
        <RowMenu
          data={data}
          index={index}
          menu={menu}
          quickMenuOpen={quickMenuOpen}
          onQuickMenuClick={onQuickMenuClick}
          menuOpen={menuOpen}
          quickMenuOption={quickMenuOption}
        />
      )}
    </DoubleRow>
  );
};
